var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[_c('Checkbox',{on:{"input":_vm.onChange}},[_c('div',{attrs:{"slot":"option"},slot:"option"},[_c('label',{class:_vm.isDarkMode ? 'text-white': 'text-gray-500'},[_vm._v(_vm._s(_vm.$t("I agree to receive advertising or promotional information") + ".")+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }